module.exports = __webpack_public_path__ + "static/media/society-01@2x.ff97275c.png";